import React from "react";
import "./our_products.css";
import { CDN_BASE_URL } from "../../config/cdn";

const OurProducts = () => {

    /* ================= CTA TRACKING ================= */
    const trackClick = (eventName, label, url) => {
        if (window.gtag) {
            window.gtag("event", {
                event_category: "Product CTA",
                event_label: label,
                value: 1,
            });
        }
        window.open(url, "_blank");
    };

    return (
        <div className="our-products-page">

            {/* ================= HERO ================= */}
            <section className="products-hero">
                <div className="op-hero-content">
                    <span className="hero-badge">✨ Enterprise Healthcare Solutions</span>

                    <h1>
                        MedRCM Technology
                        <span>Products Suite</span>
                    </h1>

                    <p>
                        Transform your healthcare operations with cutting-edge technology
                        solutions designed for efficiency, insights, and growth
                    </p>

                    <div className="hero-stats">
                        <div className="stat-card">
                            <div className="stat-icon blue">📈</div>
                            <h3>5000+</h3>
                            <p>Active Users Daily</p>
                        </div>

                        <div className="stat-card">
                            <div className="stat-icon purple">⚡</div>
                            <h3>99.9%</h3>
                            <p>System Uptime</p>
                        </div>

                        <div className="stat-card">
                            <div className="stat-icon green">🔒</div>
                            <h3>SOC 2</h3>
                            <p>Security Certified</p>
                        </div>
                    </div>
                </div>

                <div className="hero-wave">
                    <svg viewBox="0 0 1440 160" preserveAspectRatio="none">
                        <path
                            d="M0,0 H1440 V60
                             C1200,120 960,140 720,140
                             480,140 240,120 0,60 Z"
                            fill="#ffffff"
                        />
                    </svg>
                </div>
            </section>

            {/* ================= HEADER ================= */}
            <section className="products-header">
                <span>OUR SOLUTIONS</span>
                <h2>Powerful Product Suite</h2>
                <div className="header-line"></div>
                <p>
                    Transform your healthcare operations with innovative tools designed
                    for productivity, analytics, and seamless collaboration
                </p>
            </section>




            {/* ================= PRODUCT 1 ================= */}
            <section className="product-row">
                <div className="product-image">
                    <img
                        src={`${CDN_BASE_URL}/images/PT.png`}
                        alt="Productivity Tracker Dashboard"
                        className="product-image-img"
                    />

                    {/* <span className="product-badge blue">Most Popular</span> */}
                </div>

                <div className="product-content">
                    <span className="product-category">ANALYTICS & REPORTING</span>
                    <h3>Productivity Tracker</h3>
                    <span className="product-badge-inline">Most Popular</span>

                    <p>
                        A modern Productivity Tracker designed to help organizations efficiently
                        monitor employee work activity, timesheets, and performance metrics.
                    </p>

                    <div className="product-stats">
                        <div>
                            <strong>12+</strong>
                            <span>Report Types</span>
                        </div>
                        <div>
                            <strong>50+</strong>
                            <span>Data Points Tracked</span>
                        </div>
                    </div>

                    <ul>
                        <li>Daily, weekly, monthly, quarterly, yearly reports</li>
                        <li>Employee-wise task and timesheet tracking</li>
                        <li>Clean, responsive, and user-friendly UI</li>
                        <li>Advanced filtering & analytics</li>
                    </ul>

                    <button
                        className="primary-btn"
                        onClick={() =>
                            trackClick(
                                "click_reports_dashboard",
                                "Reports Dashboard",
                                "https://productivity-tracker.medrcmwf.com"
                            )
                        }
                    >
                        View Live Dashboard →
                    </button>
                </div>
            </section>

            {/* ================= PRODUCT 2 ================= */}
            <section className="product-row reverse">
                <div className="product-content">
                    <span className="product-category">EXECUTIVE ANALYTICS</span>
                    <h3 className="product-title">
                        Healthcare Executive Dashboard
                        <span className="product-badge-inline enterprise">Enterprise</span>
                    </h3>


                    <p>
                        Enterprise-grade analytics and insights platform designed for
                        C-suite executives to monitor financial health and operational KPIs.
                    </p>

                    <div className="product-stats">
                        <div>
                            <strong>25+</strong>
                            <span>KPI Metrics</span>
                        </div>
                        <div>
                            <strong>Real-time</strong>
                            <span>Data Updates</span>
                        </div>
                    </div>

                    <ul>
                        <li>Real-time financial KPIs</li>
                        <li>GCR & denial rate tracking</li>
                        <li>Detailed revenue cycle analysis</li>
                        <li>Interactive date range filtering</li>
                    </ul>

                    <button
                        className="primary-btn"
                        onClick={() =>
                            trackClick(
                                "click_executive_dashboard",
                                "Executive Dashboard",
                                "https://executive.medrcmwf.com"
                            )
                        }
                    >
                        Open Executive Dashboard →
                    </button>
                </div>

                <div className="product-image">
                    <img
                        src={`${CDN_BASE_URL}/images/executive_dash.png`}
                        alt="Productivity Tracker Dashboard"
                        className="product-image-img"
                    />
                    {/* <span className="product-badge purple">Enterprise</span> */}
                </div>
            </section>

            {/* ================= PRODUCT 3 =================
            <section className="product-row">
                <div className="product-image">
                    <img
                        src="/assets/images/git.png"
                        alt="Productivity Tracker Dashboard"
                        className="product-image-img"
                    />
                    <span className="product-badge green">Developer Tools</span>
                </div>

                <div className="product-content">
                    <span className="product-category">TECHNOLOGY PLATFORM</span>
                    <h3>Technology Platform</h3>

                    <p>
                        Centralized platform for development teams to manage repositories,
                        collaborate efficiently, and maintain infrastructure.
                    </p>

                    <div className="product-stats">
                        <div>
                            <strong>10+</strong>
                            <span>Repositories</span>
                        </div>
                        <div>
                            <strong>9+</strong>
                            <span>Team Members</span>
                        </div>
                    </div>

                    <ul>
                        <li>Multi-repository management</li>
                        <li>Role-based access control</li>
                        <li>Code review workflows</li>
                        <li>Real-time collaboration</li>
                    </ul>

                    <button
                        className="primary-btn"
                        onClick={() =>
                            trackClick(
                                "click_technology_platform",
                                "Technology Platform",
                                "https://code.medrcmwf.com"
                            )
                        }
                    >
                        Go to Platform →
                    </button>
                </div>
            </section> */}

        </div>
    );
};

export default OurProducts;
